<template>
  <div class="user-info-container">
    <div class="user-info--content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

export default {
  name: "UserInfo",
  computed: {
    ...mapGetters("agency", ["currentAgency", "isAgencyConnecting"]),
    isProfileTab() {
      return this.$route.name === "User Profile";
    },
    isTemplatesTab() {
      return this.$route.name === "User Message Templates";
    },
  }

}
</script>

<style lang="scss">
.user-info-container {
  width: 100%;
  height: 100%;
}

.user-info--content {
  width: 100%;
  height: 100%;
}
</style>
